import styled from 'styled-components'

export const UserManagementWrapper = styled.div`
  .SearchAndFilters {
    padding-left: 40px;
  }

  h1 {
    margin-bottom: 10px;
    font-weight: bold;
  }
  .user-container {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    .title-user-management {
      display: flex;
      align-items: center;
    }
    .add-user {
      background-color: rgba(238, 67, 96, 1);
      text-transform: none;
      border-radius: 17px;
    }
  }
  .add-user-wrapper {
    display: flex;
    height: 40px;
  }
  .user-filters {
    overflow: hidden;
    padding: 30px 40px;
    background-color: ${props => props.theme.colors.white};

    .role-filter,
    .status-filter,
    .client-filter {
      float: right;
      margin-left: 30px;
      .form-select {
        width: 165px !important;
      }
    }
  }

  .table-wrapper {
    width: 100%;
    padding: 10px;
  }

  table {
    thead {
      background: none;
      th {
        padding: 0px 0px 15px 0px !important;
        background: none;
        font-size: 16px !important;
        font-weight: 100 !important;
        text-transform: none;
        font-family: 'Proxima Nova', sans-serif;
        letter-spacing: normal;
        cursor: default !important;
      }
    }

    tr {
      background: none !important;
    }

    tr th:last-child {
      max-width: 35px;
      padding-right: 15px !important;
    }

    tr th:nth-child(1) {
      width: 370px;
    }
    tr th:nth-child(2) {
      width: 330px;
    }

    tr th:first-child {
      padding-left: 15px !important;
    }

    tbody {
      background-color: rgba(255, 255, 255, 1);
      box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
      tr th {
        padding: 0px !important;
      }

      tr:first-child th {
        padding-top: 15px !important;
      }

      tr:last-child th {
        padding-bottom: 30px !important;
      }
    }
  }

  table tbody tr:first-child th:first-child {
    border-top-left-radius: 8px;
  }

  table tbody tr:first-child th:last-child {
    border-top-right-radius: 8px;
  }

  table tbody tr:last-child th:first-child {
    border-bottom-left-radius: 8px;
  }

  table tbody tr:last-child th:last-child {
    border-bottom-right-radius: 8px;
  }
`
